module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-dialog', {
    ref: "dialog",
    on: {
      "close": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('md-dialog-title', [_vm._v("\n    Добавление ссылки на источник\n  ")]), _vm._v(" "), _c('md-dialog-content', {
    staticClass: "source-dialog-content"
  }, [_c('source-dialog-form', {
    attrs: {
      "value": _vm.content
    },
    on: {
      "input": _vm.setContent
    }
  })], 1), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v("Отмена")]), _vm._v(" "), (_vm.action === 'add') ? _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": _vm.onAdd
    }
  }, [_vm._v("Добавить")]) : _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": _vm.onSave
    }
  }, [_vm._v("Сохранить")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8775666c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SourceDialogView.vue
// module id = 1017
// module chunks = 1